/**
 * UTF-8 BOM 付き CSV 生成 (純粋関数)。
 *
 * SPEC §4.4 準拠:
 * - UTF-8 BOM (\uFEFF) 先頭付与 → Excel で文字化けしない
 * - RFC 4180 準拠のクォート (値にカンマ / 改行 / ダブルクォートを含む場合にのみクォート)
 * - 改行は LF (Excel・Google Sheets ともに解釈可能)
 *
 * フィールド: filename, caption (C-MATCH の「画像別キャプション一括貼付」形式)
 */

export interface CaptionRow {
  readonly filename: string;
  readonly caption: string;
}

const BOM = '\uFEFF';
const HEADER = 'filename,caption';

export function buildCaptionsCsv(rows: readonly CaptionRow[]): string {
  const lines = [HEADER];
  for (const row of rows) {
    lines.push(`${escapeField(row.filename)},${escapeField(row.caption)}`);
  }
  return BOM + lines.join('\n');
}

/**
 * Blob として生成 (ZIP に入れる用)。MIME は `text/csv`、charset=utf-8。
 */
export function buildCaptionsCsvBlob(rows: readonly CaptionRow[]): Blob {
  const content = buildCaptionsCsv(rows);
  return new Blob([content], { type: 'text/csv;charset=utf-8' });
}

function escapeField(raw: string): string {
  if (!needsQuote(raw)) return raw;
  return `"${raw.replace(/"/g, '""')}"`;
}

function needsQuote(raw: string): boolean {
  return /[",\r\n]/.test(raw);
}
